export default __webpack_public_path__ + "static/media/infra-12.2667bf4f.webp";